import { type ReactNode, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useScreenSize } from '@banhala/ui-kit';

/**
 * 도킹된 하단 버튼 위에 떠 있는 플로팅들의 공통 레이어.
 *
 * 도킹 영역 컨테이너의 자식으로 두고 뷰포트 크기만큼을 `top: -height` 로 끌어올려,
 * 레이어의 하단이 항상 도킹 영역의 상단에 붙게 만든다. 넛지/타임세일 배너로 도킹 영역
 * 높이가 바뀌어도 같은 레이아웃 패스에서 함께 올라가므로 높이를 계산해 내려줄 필요가 없다.
 * 자식은 도킹 영역 높이를 모른 채 `bottom` 기준으로만 배치하면 된다.
 */
export const BottomDockedFloatingLayer = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { width, height } = useScreenSize();

  const style = useMemo(
    () => [styles.layer, { top: -height, width, height }],
    [width, height],
  );

  return (
    // box-none: 레이어 자체는 터치를 통과시키고 자식만 터치를 받는다.
    <View style={style} pointerEvents={'box-none'}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  layer: {
    position: 'absolute',
    left: "50%",
    transform: [{ translateX: '-50%' }],
    justifyContent: 'flex-end',
  },
});
